import ScrollReveal from "scrollreveal";
import componentTimelineStore from "./component-animations";

// We want components to only play their animation if the element is inside a section that has scroll reveal

// A component will have its own animation sequence

const scrollRevealAnimations = {
	revealAndPlay: {
		delay: 1000,
		opacity: 1,
		easing: 'ease-in',
	},
	fadeInEffect: {
		delay: 1000,
		opacity: 0,
		duration: 1000,
		easing: 'ease-in-out'
	},
	slideUpAndPlay: {
		opacity: 1,
		delay: 1000,
		distance: "-200px",
		duration: 1500,
		easing: 'ease-in-out'
	}
}

function setupNestedComponentAnimation(srBlock) {
	
		// Get the SR Block animation style
		const srBlockAnimation = srBlock.getAttribute('data-scroll-reveal') === '' ? 'fadeInEffect' : srBlock.getAttribute('data-scroll-reveal');
		const newScrollRevealAnimation = { ...scrollRevealAnimations[srBlockAnimation] };
		
		
		// Locate a animejs component within the scroll reveal block
		const srBlockComponent = srBlock.querySelector('[data-anime-tl]');

		if (srBlockComponent !== null) {

			// Grab the components data-anime-tl value
			const animeJsTimeline = srBlockComponent.getAttribute('data-anime-tl');

			const callbackAnimation = componentTimelineStore[animeJsTimeline];
			
			callbackAnimation.setupAnimation(srBlockComponent);
			
			newScrollRevealAnimation.afterReveal = function() {
				callbackAnimation.playAnimation(srBlockComponent);
			}
			
			ScrollReveal().reveal(srBlock, newScrollRevealAnimation);
		} else {
			ScrollReveal().reveal(srBlock, newScrollRevealAnimation);
		}
}

function pageScrollReveal () {
	const scrollRevealBlock = document.querySelectorAll('[data-scroll-reveal]');

	if (scrollRevealBlock.length > 0) {
		for (var i = 0; i < scrollRevealBlock.length; i++) {
			
			const loopedscrollRevealBlock = scrollRevealBlock[i];

			setupNestedComponentAnimation(loopedscrollRevealBlock);	
		}
	}		
}

export default pageScrollReveal;